import React from "react";

export default function FirstTradeAnalysisPopup({ currentPopup, onClose }) {
  // Only render if this specific popup is active
  if (currentPopup?.id !== 'firstTradeAnalysisPopup') return null;

  const { theme, headline, message } = currentPopup.data;

  const borderColor = 
    theme === 'green' ? 'border-green-500' :
    theme === 'yellow' ? 'border-yellow-500' :
    theme === 'red' ? 'border-red-500' :
    'border-blue-500';

  const textColor = 
    theme === 'green' ? 'text-green-600 dark:text-green-400' :
    theme === 'yellow' ? 'text-yellow-600 dark:text-yellow-400' :
    theme === 'red' ? 'text-red-600 dark:text-red-400' :
    'text-blue-600 dark:text-blue-400';

  const btnColor = 
    theme === 'green' ? 'bg-green-600 hover:bg-green-700' :
    theme === 'yellow' ? 'bg-yellow-600 hover:bg-yellow-700' :
    theme === 'red' ? 'bg-red-600 hover:bg-red-700' :
    'bg-blue-600 hover:bg-blue-700';

  const icon = 
    theme === 'green' ? '🏆' :
    theme === 'yellow' ? '⚠️' :
    theme === 'red' ? '🛑' : '🛡️';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 animate-fadeIn">
      <div className={`bg-white dark:bg-gray-900 rounded-xl shadow-2xl p-8 max-w-md w-full border-2 relative animate-fadeIn ${borderColor}`}>
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
          onClick={onClose}
          aria-label="Close"
        >×</button>

        <h2 className={`text-xl font-bold mb-4 flex items-center ${textColor}`}>
          <span className="mr-3 text-2xl">{icon}</span>
          {headline}
        </h2>

        <div className="mb-6 font-medium text-gray-700 dark:text-gray-200 whitespace-pre-line leading-relaxed">
          {message}
        </div>

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className={`px-6 py-2 rounded-lg font-bold text-white shadow-lg transition transform active:scale-95 ${btnColor}`}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}